export default __webpack_public_path__ + "static/media/homeBijoux3.677e82b0.jpg";